import React, { useState } from 'react';
import styles from './Box.module.scss';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import InfoButton from '../../Atoms/InfoButton/InfoButton';
import ActivityStatus from '../../Atoms/Inputs/ActivityStatus';
import { useMutation } from 'react-query';
import { API_URL, securityHeaders } from '../../../Constants';
import axios from 'axios';
import { useToast } from '../Custom/CustomToaster/Toast';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

function MajorBox({
  id,
  title,
  active,
  date,
  image,
  onClick,
  setDeleteMode,
  setAddEditMode,
  setSelectedItem,
  setSelectedEchoMagazine,
  item,
  refetchEchoMagazine,
  setShowDetails,
}) {
  const [isActive, setIsActive] = useState(active);
  const customizedToast = useToast();
  const activateEvent = useMutation({
    mutationFn: () => {
      return axios.post(
        API_URL + `/api/EchoMagazine/SetMagazineActive/${id}/${!isActive}`,
        {},
        {
          headers: securityHeaders,
        }
      );
    },
    onSuccess: (data) => {
      setIsActive(!isActive);
      refetchEchoMagazine();
      customizedToast.open('Status is changed successfully');
    },
    onError: (error) => {
      //alert(error?.message);
    },
  });

  const menuItems = [
    {
      label: 'تعديل',
      icon: editSvg,
      onClick: () => {
        setAddEditMode(true);
        setSelectedEchoMagazine(item);
        setShowDetails(null);
      },
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () => {
        setDeleteMode(true);
        setSelectedItem(id);
      },
    },
  ];
  let color = 'grey';

  // Array of month names
  var monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  var dateMonth = new Date(date);

  return (
    <div onClick={onClick} className={`${styles['major-box']} `}>
      <InfoButton
        icon={moreInfo}
        className={styles['more-info']}
        data={menuItems}
        left
      />
      <div className={styles['grid-container']}>
        <div className={styles['image-container']}>
          <img src={sanitizeAndValidateUrl(image)} alt="Pre" />
        </div>
        <p className={styles['boxTitle']}>{title}</p>
        <p>
          <b style={{ textTransform: '' }} className={styles['date']}>
            {monthNames[dateMonth.getMonth()] + ' '}
            {date.substring(0, 4)}
          </b>
          <ActivityStatus isActive={isActive} activate={activateEvent} />
        </p>
      </div>
    </div>
  );
}

export default MajorBox;
